import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
//image
import vuepay_large_logo from '../../assets/images/vuepaylogonav@5x.png';
import loading_blue from '../../assets/gif/loading_blue.gif';
//libraries
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/libphonenumber.js';
import 'react-intl-tel-input/dist/main.css';
//internal imports
import * as actions from '../../actions/index';
import VerifyMobile from '../../components/VerifyMobile'
import { isEmpty, navigate, required, vuepayAlert, vuePayLog } from "../../util/utility";
import { getData, LOGIN } from "../../util/storage";
import strings from "../../util/strings";
import { checkIfUserDataAvailable, renderField } from "../../util/account_management";
import {
    checkForBroadcaster,
    checkIfBroadcaster,
    checkIfMobileNumberIsVerified,
    checkIfRegisterBroadcaster,
    checkIfUserRequestedToBecomeBroadcaster,
    registerAsBroadcaster,
    showMobileVerification
} from "../../util/broadcaster/register_util";

class BroadcasterRegister extends Component {

    constructor(props) {
        super(props);
        this.state = {
            componentMounted: false,
            country_code: '',
            mobile_number: '',
            mobile_number_error: false,
            mobile_number_valid: true,
            SubmitClicked: false,
            count: 0,
            resent_otp: false,
            numberUpdated: false,
            numberUpdatedData: null
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
        this.mobileNumberChange = this.mobileNumberChange.bind(this);
    }

    componentWillUnmount() {

        this.setState({
            componentMounted: false,
        })
    }

    componentDidMount() {
        document.getElementsByClassName("modal-overlay")[0].style.display = "inherit";
        this.setState({
            componentMounted: true,
            country_code: this.props.account_management.userDetails && this.props.account_management.userDetails.country_code ? this.props.account_management.userDetails.country_code : this.props.location.state.country_code,
            mobile_number: this.props.account_management.userDetails && this.props.account_management.userDetails.phone_number ? this.props.account_management.userDetails.phone_number : this.props.location.state.mobile_number,
            numberUpdatedData: this.props.account_management.userDetails && this.props.account_management.userDetails.country_code ? this.props.account_management.userDetails.country_code + this.props.account_management.userDetails.phone_number : this.props.location.state.country_code + this.props.location.state.mobile_number
        })

        this.props.hideLeftBar(); //hide the leftbar
    }

    /**
     * This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        //check if we have user information
        if (checkIfUserDataAvailable(nextProps)) {

            //check if user has registered with us as a broadcaster
            if (checkIfRegisterBroadcaster(nextProps)) {
                //check if they have not verified their mobile number
                if (((!checkIfMobileNumberIsVerified(nextProps)))) {
                    if (this.state.SubmitClicked) {
                        if (checkForBroadcaster(nextProps, "resend_otp")) {
                            if (nextProps.broadcaster.resend_otp.payload !== null && !this.props.broadcaster.resend_otp.isFetching) {
                                this.setState({
                                    resent_otp: true
                                })
                            }
                        }
                        else {
                            if (!this.state.resent_otp) {
                                this.resendOTP()
                            }
                        }
                        showMobileVerification();
                    }



                } else if (!checkIfBroadcaster(nextProps)) {
                    //check if status of the user is pending verification from the admin
                    registerAsBroadcaster(() => {
                        navigate(this.props, "broadcaster_create_profile");
                    });
                } else {
                    //move to broadcaster create profile if not any
                    if (this.state.SubmitClicked) {
                        registerAsBroadcaster(() => {
                            navigate(this.props, "broadcaster_create_profile");
                        });
                    }
                }

            } else {
                //since user has not registered with us they would always land to this block
                if (checkIfUserRequestedToBecomeBroadcaster(nextProps)) {

                    const payload = nextProps.broadcaster.register.payload;


                    if (payload.status_code === 201 || payload.status_code === 200) {
                        //response received from the server was 201 i.e. user is successfully registered
                        //as a broadcaster and now they have to verify their account (i.e. verify mobile number)

                        //check if number is updated then ask to verify OTP
                        if (this.state.numberUpdated) {
                            showMobileVerification();
                            vuepayAlert("success", payload.message);
                        } else {


                            //update the props to reset the registration details using the action (resetBroadcastRegister)
                            nextProps.resetBroadcastRegister();

                            //show a success message
                            vuepayAlert("success", payload.message, () => {
                                //since the request for creating a broadcaster account was accepted by the webservice
                                //ask the user to enter the 5 digit OTP
                                getData(LOGIN)
                                    .then((data) => {
                                        if (!isEmpty(data)) {
                                            //console.log(data);
                                        }
                                    })

                                registerAsBroadcaster(() => {
                                    navigate(this.props, "broadcaster_create_profile");
                                });
                            });
                        }
                    } else {
                        //update the props to reset the registration details using the action (resetBroadcastRegister)
                        nextProps.resetBroadcastRegister();

                        //show a error message
                        vuepayAlert("error", payload.message);
                    }
                }
            }
        } else {
            //if user lands to this screen and we don't have user information instead of showing blank page we would
            // redirect them to dashboard
            nextProps.history.push("/dashboard");
        }
    }


    resendOTP() {

        if (!this.props.broadcaster.resend_otp.isFetching) {

            //get user data locally from the storage
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        //dispatch an action (broadcastRegister)
                        this.props.resentOTP(data.token, data.api_token, {
                            device: this.props.device
                        });
                    }
                })
        }
    }

    /**
     * listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(e) {
        this.setState({
            count: e.target.value.length,
        });
    }

    /**
     * listener for mobile number change we use this to validate if the mobile number is valid as per the country policy
     * @param status
     * @param value
     * @param countryData
     * @param number
     * @param id
     */
    mobileNumberChange = (status, value, countryData, number, id) => {
        let formattedNumber = number.replace(/ /g, '')
        if (formattedNumber.includes(this.props.account_management.userDetails.phone_number)) {
            // //console.log("inside if::::number",number,"This.state mobile_number",this.state.mobile_number);

            this.setState({ numberUpdated: false })
        }
        else {
            // //console.log("inside else part ::formattedNumber",formattedNumber);

            this.setState({
                numberUpdated: true,
                numberUpdatedData: formattedNumber
            })
        }

        vuePayLog("register.js", "mobileNumberChange", { status, value, countryData, number, id });
        //this is to avoid memory leaks which happens when component is unmounted but still this function gets called from render
        if (this.state.componentMounted) {
            if (status) {
                this.setState({
                    country_code: "+" + countryData.dialCode,
                    mobile_number: value,
                    mobile_number_error: false,
                    mobile_number_valid: true,
                });
            } else {
                this.setState({
                    mobile_number_error: true,
                    mobile_number_valid: false
                });
            }
        }
    };

    /**
     * this is redux-form on form submit listener this is called only when the form fields are valid
     * @param values
     */
    onSubmit(values) {
        //mobile_number_valid this is updated in the mobileNumberChange Listener
        this.setState({ SubmitClicked: true })
        if (this.state.mobile_number_valid) {
            /**
             * if the mobile number is valid we check if the channel description meets the minimum business requirements
             * @NOTE We haven't used redux-form for text area due to the nature of customization is needed for text area
             */
            // Below condition is commented according to ticket on Trello (https://trello.com/c/S9Ubbi7r/25-changes-to-the-wording-on-screens-during-user-to-broadcaster-set-up): Remove description field from register.
            // if (this.state.count > minimum_characters_for_channel_description) {
            const formData = {
                firstname: values.firstname,
                lastname: values.lastname,
                country_code: this.state.country_code,
                mobile_number: this.state.mobile_number.includes('+') ? this.state.mobile_number.substr(3, this.state.mobile_number.length) : this.state.mobile_number,
                // description: values.description,
                device: this.props.device
            };

            //get user data locally from the storage
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        //dispatch an action (broadcastRegister)
                        this.props.broadcastRegister(data.token, data.api_token, formData);
                    }
                })
            // }
        } else {
            //update the state that the mobile number is not valid and we couldn't submit the form
            this.setState({
                mobile_number_error: true,
            });
        }
    }

    render() {

        const { handleSubmit } = this.props;
        const { country_code, mobile_number } = this.state

        return (
            <div>
                <VerifyMobile history={this.props.history} />
                <main role="main" className="">
                    <div className="login-container">
                        <div className="popup-header">


                            <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    document.getElementsByClassName("modal-overlay")[0].style.display = "none";
                                    this.props.history.push('/dashboard')
                                }
                                }
                            >
                                <img alt={"close-icon"} src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                            </button>

                        </div>
                        <div className="row">

                            <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                style={{ borderRight: '1px solid #e7e7e7' }}>
                                <div className="login-content">
                                    <img src={vuepay_large_logo} className="img-fluid" />
                                    <h4 style={{ color: '#FFFFFF' }}>{strings.broadcaster.register_to_become_a_broadcaster_left_area_title}</h4>
                                    <p style={{ color: '#FFFFFF' }}>{strings.broadcaster.register_to_become_a_broadcaster_left_area_subtitle}</p>

                                </div>
                            </div>
                            <div className="col-md-6 bg-white d-flex align-items-center">
                                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                    <h4>{strings.broadcaster.register_to_become_a_broadcaster_title}</h4>
                                    <p><span>{strings.broadcaster.register_to_become_a_broadcaster_subtitle}</span></p>
                                    <br />
                                    <Field
                                        label="First name"
                                        name="firstname"
                                        type="text"
                                        username={null}
                                        email={true}
                                        validate={[required]}
                                        component={renderField}
                                    />
                                    <br />
                                    <Field
                                        label="Last name"
                                        name="lastname"
                                        type="text"
                                        username={null}
                                        email={true}
                                        validate={[required]}
                                        component={renderField}
                                    />
                                    <br />
                                    <div className="form-group">
                                        <label>Mobile number</label>
                                        <div className="input-group" style={{ height: 47 }}>
                                            <IntlTelInput
                                                value={this.state.numberUpdatedData}
                                                onPhoneNumberChange={this.mobileNumberChange}
                                                onPhoneNumberBlur={this.mobileNumberChange}
                                                preferredCountries={['gb']}
                                                css={['intl-tel-input', 'form-control form-control-tel']}
                                                utilsScript={'libphonenumber.js'}
                                            />
                                        </div>
                                        {
                                            this.state.mobile_number_error &&
                                            <p className="text-danger">Please enter valid mobile number.</p>
                                        }
                                    </div>
                                    <br />

                                    <div className="mt-4 text-right">
                                        <button className="btn btn-outline-primary">
                                            {
                                                this.props.broadcaster.register.isFetching
                                                    ?
                                                    <img src={loading_blue} alt={"Loading"} width={26} height={26} />
                                                    :
                                                    'Continue'
                                            }
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}


function mapStateToProps(state) {

    return {
        account_management: state.account_management,
        broadcaster: {
            register: state.broadcaster_register,
            resend_otp: state.broadcaster_resend_otp
        },
        device: state.device.payload
    };
}

export default reduxForm({
    form: 'BroadcasterRegisterForm'
})(
    connect(mapStateToProps, actions)(BroadcasterRegister)
);